import { combineEpics } from 'redux-observable';
import { of, concat } from 'rxjs';
import makeBasicFetchEpic from '@eGroupTeam/utils/makeBasicFetchEpic';
import { fromJS } from 'immutable';

import { clearApiResponse } from '@eGroupTeam/redux-modules/immutable/apis';
import { setSelectedOrg } from 'redux/modules/common';
import { fetchGetOrganizations } from 'components/RouterRoot/actions';
import { push } from 'connected-react-router/immutable';
import {
  fetchPostOrganizationRequest,
  fetchPostOrganizationSuccess,
  fetchPostOrganizationFailure,
  FETCH_POST_ORGANIZATION,
} from './redux';

export const fetchPostOrganizationEpic = makeBasicFetchEpic({
  actionType: FETCH_POST_ORGANIZATION,
  apiName: 'member.fetchPostOrganization',
  fetchRequest: fetchPostOrganizationRequest,
  handleSuccess: (response) => [
    clearApiResponse(fetchGetOrganizations()),
    fetchGetOrganizations(),
    fetchPostOrganizationSuccess(),
    setSelectedOrg(fromJS(response.data)),
    push('/me'),
  ],
  handleFailure: (error, { state$, action, apiErrorsHandler }) =>
    concat(
      apiErrorsHandler(error, { state$, action }),
      of(fetchPostOrganizationFailure(error))
    ),
});

export default combineEpics(fetchPostOrganizationEpic);
